import {NgModule} from '@angular/core';
import {CommonModule, DatePipe} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import {RouterModule} from '@angular/router';
import {ErrorPageComponent} from './error-page/error-page.component';

import {UserDetailsModel} from '../constants/userModel';
import {UrlConstants} from '../constants/url-constants';
import { PrintViewComponent } from './print-view/print-view.component';
import { FmComponentsModule } from '@fm-ui-adk/components-3/components_module';
import { FmCalendarModule } from '@fm-ui-adk/components-3/fm-calendar';
import { FmButtonModule } from '@fm-ui-adk/components-3/fm-button';
import { FmSelectModule } from '@fm-ui-adk/components-3/fm-select';
import { FmRadioModule } from '@fm-ui-adk/components-3/fm-radio';
import { FmTextInputModule } from '@fm-ui-adk/components-3/fm-text-input';
import { FmTableModule } from '@fm-ui-adk/components-3/fm-table';
import { FmFileUploadModule } from '@fm-ui-adk/components-3/fm-file-upload';


@NgModule({
  declarations: [
    ErrorPageComponent,
    PrintViewComponent
  ],
  exports: [FmComponentsModule, FmCalendarModule,
    FmButtonModule,
    FmSelectModule,
    FmRadioModule,
    FmTextInputModule, FmTableModule, FmFileUploadModule,
    RouterModule,
    ReactiveFormsModule,
    ErrorPageComponent
  ],
  imports: [
    CommonModule, FmComponentsModule.forRoot(), FormsModule, FmCalendarModule,
    FmButtonModule,
    FmSelectModule,
    FmFileUploadModule,
    RouterModule,
    FmRadioModule,
    FmTextInputModule, FmTableModule,
    ReactiveFormsModule
  ],
  providers: [UrlConstants, DatePipe, UserDetailsModel]
})
export class SharedModule {
}
